import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowPathIcon } from "@heroicons/react/24/solid";
import { fetchAreas } from "../../../../redux/reducer/areaReducer";
import { AddSubCategory } from "../../../../redux/reducer/subCategoryReducer";

const AddSubCategoryForm = ({ onClose }) => {
  const dispatch = useDispatch();
  const { areas } = useSelector((state) => state.areas);

  const [selectedAreaId, setSelectedAreaId] = useState("");
  const [selectedSuperCategoryId, setSelectedSuperCategoryId] = useState("");
  const [selectedSuperCategories, setSelectedSuperCategories] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const [nameEn, setNameEn] = useState("");
  const [nameAr, setNameAr] = useState("");
  const [title, setTitle] = useState("");
  const [image, setImage] = useState(null);

  useEffect(() => {
    dispatch(fetchAreas());
  }, [dispatch]);

  useEffect(() => {
    const selectedArea = areas?.find((area) => area._id === selectedAreaId);
    if (selectedArea) {
      setSelectedSuperCategories(selectedArea.category || []);
    } else {
      setSelectedSuperCategories([]);
    }
    // console.log(selectedArea)
  }, [selectedAreaId, areas]);

  // console.log(selectedSuperCategoryId)
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 bg-opacity-30bg-black">
      <div className="bg-white p-6 rounded-xl w-[90%] max-w-lg shadow-xl space-y-4">
        <h2 className="text-xl font-bold text-black">Add New SubCategory</h2>

        {/* Area Dropdown */}
        <select
          className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
          onChange={(e) => setSelectedAreaId(e.target.value)}
          required
        >
          <option disabled selected value="" className="text-black">
            Choose Area
          </option>
          {areas?.map((area) => (
            <option key={area._id} value={area._id} className="text-black">
              {area.name?.en}
            </option>
          ))}
        </select>

        {/* Category Dropdown based on selected Area */}
        <select
          className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
          onChange={(e) => setSelectedSuperCategoryId(e.target.value)}
          required
        >
          <option disabled selected value="" className="text-black">
            Choose Category
          </option>
          {selectedSuperCategories?.map((cat) => (
            <option key={cat._id} value={cat._id} className="text-black">
              {cat.title?.en}
            </option>
          ))}
        </select>

        <hr />

        <div className="flex gap-2">
          <input
            type="text"
            placeholder="Name EN"
            className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
            value={nameEn}
            onChange={(e) => setNameEn(e.target.value)}
            required
          />
          <input
            type="text"
            placeholder="Name AR"
            className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
            value={nameAr}
            onChange={(e) => setNameAr(e.target.value)}
            required
          />
        </div>

        <div className="flex gap-2">
          <input
            type="text"
            placeholder="Tilte"
            className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
          <input
            type="file"
            className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
            onChange={(e) => setImage(e.target.files[0])}
            required
          />
        </div>

        <div className="flex justify-end gap-4">
          {isLoading ? null : (
            <button
              className="px-4 py-2 text-sm text-white duration-300 bg-gray-600 rounded-lg hover:bg-gray-800"
              onClick={onClose}
            >
              Cancel
            </button>
          )}
          {isLoading ? (
            <ArrowPathIcon className="w-10 h-10 p-2 text-white rounded-full animate-spin bg-custom-yellow" />
          ) : (
            <button
              className="px-4 py-2 text-sm text-black duration-300 rounded-lg hover:text-white bg-custom-yellow hover:bg-yellow-600"
              onClick={() => {
                setIsLoading(true);

                dispatch(
                  AddSubCategory({
                    data: {
                      selectedAreaId,
                      selectedSuperCategoryId,
                      nameEn,
                      nameAr,
                      title,
                      image,
                    },
                  })
                )
                  .unwrap()
                  .then(() => {
                    alert("The SubCategory has been added successfully.");
                  })
                  .catch((error) => {
                    alert("Failed to add the SubCategory: " + error);
                  })
                  .finally(() => {
                    setIsLoading(false); 
                    onClose();
                  });
              }}
            >
              Submit
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddSubCategoryForm;
